const actions = {
    getDoctorList(ctx, item) {
        //调用axios
        api.request("/register/findSurgeryRegisterMenuList", {}, (res) => {
            ctx.commit('GETGENEMUTATION', res.data);
        });
    }


}
export default actions